/**
 * Javascript file for searching for technologies.
 * @author Adrian Rebmann, Steffen Schuhmann, Yannik Sprengart
 */

import {
  getTechnologies,
  getTechCategories,
  getBmas,
  getProjects
} from "../../../../api";
import axios from "axios";

// Import config from correct environment
var environment = process.env.NODE_ENV;
var config = require(`../../../../../config/${environment}.json`);

export default {
  name: "TechSearchMain",
  data: () => ({
    show: false,
    fullRequest: [],
    input: {
      catKey: "get-all"
    },
    //Load Server Config
    requestUrl: `${config.server}/technology/`,
    imageLink: `${config.deployment}/static/uploads/`,

    placeholderSVG: require("../../../../assets/tech-placeholder.svg"),
    categoriesFromBackend: [],
    categories: [],
    categoriesHardcoded: [{
      text: "Alle Kategorien",
      value: "get-all"
    }],
    loading: true,
    firstLoad: true,
    searchtype: "Technologiesuche",
    technologies: [],
    searchresults: [],
    msg: "WERNER",
    searchterm: "",
    searchoptions: {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 100,
      maxPatternLength: 32,
      minMatchCharLength: 3,
      keys: ["name", "description"]
    },

    // BMAs
    allBmas: [],
    randomeBmas: [],
    //Projects
    allProjects: [],
    // Left Card
    categoryName: "Allgemein",
    categoryDescription: "",
    //StartPage
    startpage: {
      describtion: "Die Technologie-Suche soll dem Zweck dienen, schnell und zielsicher eine Auswahl an relevanten Technologien anzubieten. Um diese Auswahl möglichst genau abzustimmen, sind alle Technologien in eine von sechs Kategorien unterteilt, welche bei der Suche ausgewählt werden können. Sollte beim Suchen keine Kategorie ausgewählt worden sein, wird eine relevante Auswahl aus allen Technologien gezeigt. Durch Eingabe in das Suchfeld können spezifische Technologien namentlich erfasst oder eine Auswahl, die einem bestimmten Schlagwort hinterlegt sind, gefunden werden."
    },
    // Right Card
    projects: [],
    bricks: []
  }),
  methods: {
    search() {
      this.$search(this.searchterm, this.technologies, this.searchoptions).then(
        results => {
          this.searchresults = results;
        }
      );
    },

    fetchData() {
      this.firstLoad = true;
      getBmas()
        .then(res => {
          this.allBmas = res;
          // Get Random Projects and BMAs
          let shuffled = this.allBmas.sort(() => 0.5 - Math.random());
          this.bricks = shuffled.slice(0, 3);
        })
        .catch(err => {
          //console.log(err);
        });

      getProjects()
        .then(res => {
          this.allProjects = res;
          // Get Random Projects and BMAs
          const shuffled = this.allProjects.sort(() => 0.5 - Math.random());
          this.projects = shuffled.slice(0, 3);
        })
        .catch(err => {
          //console.log(err);
        });

      getTechnologies()
        .then(res => {
          //console.log(res);
          this.technologies = res;
          this.searchresults = res;
          this.bricks = this.randomeBmas;
          this.categoryDescription = this.startpage.describtion;
        })
        .catch(err => {
          //console.log(err);
        });

      getTechCategories()
        .then(res => {
          this.categoriesFromTheBoy = res;
          this.categoriesFromBackend = res.map(category => {
            return {
              text: category.name,
              value: category.name.replace(" ", "_")
            };
          });
          this.categories = this.categoriesHardcoded.concat(
            this.categoriesFromBackend
          );
        })
        .catch(err => {
          //console.log(err);
        })
        .finally(() => {
          setTimeout(() => {
            this.firstLoad = false;
          }, 700);
        });

      getTechnologies()
        .then((res) => {
          //console.log(res);
          this.technologies = res;
          this.searchresults = res;
          console.log(this.searchresults);
          this.bricks = this.randomeBmas;
          this.categoryDescription = this.startpage.describtion;
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    /**
     * Sets a placeholder image in the element.
     * @param {*} e  - The element where the placeholder image is to be set.
     */
    setAltImg(e) {
      e.target.src = require("../../../../assets/tech-placeholder.png");
    },



    // NEW FEATURE: Get Technologies by Category

    getTechnologieByCategorie() {
      this.firstLoad = true;
      //Set local storage
      localStorage.setItem("techsearch-category-selected", this.input.catKey);
      if (this.input.catKey == "get-all") {
        axios
          .get(this.requestUrl)
          .then(response => {
            this.technologies = response.data;
            this.searchresults = response.data;
            this.categoryDescription = this.startpage.describtion;
            this.categoryName = "Allgemein";
            // Get Random Projects and BMAs
            const shuffledBmas = this.allBmas.sort(() => 0.5 - Math.random());
            this.bricks = shuffledBmas.slice(0, 3);
            const shuffledBricks = this.allProjects.sort(
              () => 0.5 - Math.random()
            );
            this.projects = shuffledBricks.slice(0, 3);
          })
          .finally(() => {
            setTimeout(() => {
              this.firstLoad = false;
            }, 300);
          });
      } else {
        axios
          .get(this.requestUrl + "get/" + this.input.catKey)
          .then(response => {
            this.fullRequest = response.data;
            this.technologies = response.data.techs;
            this.searchresults = response.data.techs;
            this.categoryName = response.data.category;
            this.categoryDescription = response.data.description;
            this.projects = response.data.pros;
            this.bricks = response.data.bmbs;
          })
          .finally(() => {
            setTimeout(() => {
              this.firstLoad = false;
            }, 300);
          });
      }
    }
  },
  created() {
    // Check if user selected a tech category TODO: Make this better!
    if (
      localStorage.getItem("techsearch-category-selected") &&
      localStorage.getItem("techsearch-category-selected") !== "get-all"
    ) {
      this.input.catKey = localStorage.getItem("techsearch-category-selected");
      getTechCategories().then(res => {
        this.categoriesFromTheBoy = res;
        this.categoriesFromBackend = res.map(category => {
          return {
            text: category.name,
            value: category.name.replace(" ", "_")
          };
        });
        this.categories = this.categoriesHardcoded.concat(
          this.categoriesFromBackend
        );
      });
      this.getTechnologieByCategorie();
    }
    // Fetch all if category is not selected
    else {
      this.fetchData();
    }
    // this.getTechnologieByCategorie();
  },

  watch: {
    searchterm: function () {
      if (this.searchterm != "") {
        this.search();
      } else {
        this.searchresults = this.technologies;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/search/techSearchNew/views/techsearchmain.js